import { render, staticRenderFns } from "./AddPicModule.vue?vue&type=template&id=27b89c54&scoped=true&"
import script from "./AddPicModule.vue?vue&type=script&lang=js&"
export * from "./AddPicModule.vue?vue&type=script&lang=js&"
import style0 from "./AddPicModule.vue?vue&type=style&index=0&id=27b89c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b89c54",
  null
  
)

export default component.exports